<template>
  <div class="mx-auto w-100 w-md-80">
    <amio-header></amio-header>

    <div class="justify-content-center mt-5 mt-sm-6 align-items-center px-4 px-sm-5 px-md-0 w-xxl-80 mx-auto">
      <b-row cols="4">
        <b-col>
          <h1>Request a demo</h1>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="6" class="d-flex flex-column">
          <p class="sub-headline pr-md-4 pr-lg-6 pr-xl-8">
            We’ll show you our <span class="font-weight-bold">virtual assistant designer</span>
            and tailor the right solution for you.
          </p>

          <div class="d-none d-md-inline mt-5">
            <h3 class="sub-headline">Learn more about</h3>
            <ul class="mt-3">
              <li v-for="(text, i) in learnMoreTexts" :key="i" class="mt-1">
                <span class="text-muted">{{ text }}</span>
              </li>
            </ul>
          </div>

          <p class="text-muted mt-2 mt-md-5">For general questions reach us on <a href="mailto:hello@amio.io">hello@amio.io</a></p>
        </b-col>
        <b-col md="6" :class="{'d-flex flex-column justify-content-end': formSubmitted}">
          <transition name="fade" mode="out-in">
            <contact-form v-if="!formSubmitted"
                          class="mt-3 mt-md-0"
                          key="form"
                          @submit="formSubmitted = true"/>

            <thank-you v-else class="mt-3 mt-sm-5 mt-md-2" key="thanks"/>
          </transition>
        </b-col>
      </b-row>
    </div>

    <customer-references class="mt-md-6 d-none d-md-flex"/>

    <amio-footer class="mt-5 pt-7"></amio-footer>
  </div>
</template>

<script>
  import AmioFooter from '@/components/common/AmioFooter'
  import AmioHeader from '@/components/common/AmioHeader'
  import CustomerReferences from '@/components/common/CustomerReferences'
  import ContactForm from '@/components/contact/ContactForm'
  import ThankYou from '@/components/contact/ThankYou'

  export default {
    components: {
      AmioFooter,
      AmioHeader,
      CustomerReferences,
      ContactForm,
      ThankYou
    },

    data() {
      return {
        learnMoreTexts: [
          'Support automation scenarios',
          'Business case calculations',
          'Customer success stories',
          'Pricing'
        ],
        formSubmitted: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all 1s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  .fade-enter {
    transform: translateX(31px);
  }
  .fade-leave-active {
    transform: translateX(-31px);
  }
</style>
